import React, { Fragment } from "react";
import Card from "components/Card";
import FormatDateWithLocale from "components/FormatDateWithLocale";

const UserOrders = ({ formatMessage, messages, userOrders, orderItemClick }) => {
    return (
        <div className="active-orders">
            <h3 className="my-0">{formatMessage(messages.ordersHeading)}</h3>
            <div className="all-orders all-active-orders">
                {userOrders.map((order, index) => {
                    return (
                        <Fragment key={index}>
                            <Card
                                key={index}
                                isOrder
                                equalButton
                                equalTitle
                                isMobileView
                                className="cursor-pointer"
                                onItemClick={() => orderItemClick(order?.TypeOrder, order)}
                                type={
                                    order?.IsSplitAllowed === "true"
                                        ? `split-${order?.TypeOrder}`
                                        : order?.TypeOrder
                                }
                                shares={order?.Shares}
                                sharePrice={order?.SharePrice}
                                date={<FormatDateWithLocale date={order?.ExpirationDate?.split("_")[0]} />}
                                price={parseFloat(order?.Amount)}
                                status={order?.StatusOrder}
                                isOrderSplit={order?.IsSplitAllowed === "true"}
                                soldShares={order?.IsSplitAllowed == "true" ? order?.SoldShares : null}
                                reservedShares={order?.IsSplitAllowed == "true" ? order?.SharesInProgress : null}
                            />
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default UserOrders;